import Service from "../Service";
import Vue from "vue";
const resource = "/ConfigurationPriceTransport/"; //TransportPrice

export default {
  GetZon() {
    return Vue.prototype.$http.defaults.baseURL + "/TransportPrice/GetZon";
    /*  return Service.post(resource + "GetZon", "", {
             params: { requestID: requestID },
         }); */
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
  getPriceTransport(parameters, requestID) {
    return Service.post(resource + "TasTransportGetPrice", parameters, {
      params: { requestID },
    });
  },
};
